export default __webpack_public_path__ + "static/media/dishwasher-gray.fad2ba40.svg";